import React, { type KeyboardEvent, type MouseEvent, useCallback } from 'react';

import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-resource-router-next';

type LinkProps = RouterLinkProps & {
	openLinksInNewTab?: boolean;
	shouldDisplayStrikethrough?: boolean;
	testId?: string;
	wordBreak?: boolean;
};

const Link = ({
	onClick,
	openLinksInNewTab = false,
	wordBreak = true,
	shouldDisplayStrikethrough = false,
	...rest
}: LinkProps): React.JSX.Element => {
	const onClickForward = useCallback(
		(e: MouseEvent | KeyboardEvent) => {
			onClick && onClick(e);
		},
		[onClick],
	);
	return (
		<PropFilteredLink
			{...(openLinksInNewTab ? { target: '_blank', rel: 'noopener' } : {})}
			{...rest}
			onClick={onClickForward}
			style={{
				wordBreak: wordBreak ? 'break-word' : undefined,
				textDecoration: shouldDisplayStrikethrough ? 'line-through' : undefined,
			}}
		/>
	);
};

const PropFilteredLink = ({
	wordBreak: _wordBreak,
	shouldDisplayStrikethrough: _shouldDisplayStrikethrough,
	...rest
}: LinkProps) => <RouterLink {...rest} />;

export default Link;
